module.exports = __webpack_public_path__ + "static/media/jpg-file-type.84ab5858.svg";